import { z } from 'zod'

import { Day } from 'app/types/shared/day'

export const TimeSlot = z.object({
    day_start: Day,
    time_start: z.string().time(),
    day_end: Day,
    time_end: z.string().time(),
})

export type TimeSlot = z.infer<typeof TimeSlot>

/** Errors for the time slots. */
export const TimeSlotError = z.object({
    index: z.number().nonnegative(),

    /** Know if the time slot is in conflict with an other. */
    is_in_conflict: z.boolean(),

    is_day_error: z.boolean(),

    is_time_error: z.boolean(),
})
export type TimeSlotError = z.infer<typeof TimeSlotError>

export const SelfServiceTerminal = z.discriminatedUnion('has_self_service', [
    z.object({
        has_self_service: z.literal(false),
    }),
    z.object({
        has_self_service: z.literal(true),
        image: z.string().url().or(z.instanceof(File)),
        time_slots: TimeSlot.array().min(1),
    }),
])

export type SelfServiceTerminal = z.infer<typeof SelfServiceTerminal>
